<template>
    <x-modal :id="id" :title="title">
        <form :id="formId" @submit.prevent="handleSubmit">
            <fieldset :disabled="isLoading">
                <x-form-group
                    label="Tanggal Mulai"
                    :horizontal="false"
                    :isRequired="true"
                    :error="getError('start_date')"
                >
                    <input
                        type="date"
                        class="form-control"
                        v-model="fields.start_date"
                        required
                    />
                </x-form-group>

                <x-form-group
                    label="Jam"
                    :horizontal="false"
                    :isRequired="true"
                    :error="getError('time')"
                >
                    <input
                        type="time"
                        class="form-control"
                        v-model="fields.time"
                        required
                    />
                </x-form-group>
            </fieldset>
        </form>
        <template #footer>
            <x-close-modal-button :disabled="isLoading" />
            <x-submit-button
                :form="formId"
                :disabled="isLoading"
                :isLoading="isLoading"
            />
        </template>
    </x-modal>
</template>

<script>
import Axios from "axios";
import XCloseModalButton from "../../components/XCloseModalButton.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XInputDevotionCategory from "../../components/XInputDevotionCategory.vue";
import XModal from "../../components/XModal.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";
import FormErrorMixin from "../../mixins/FormErrorMixin";
import { handleValidationXhrError } from "../../helpers";

const defaultFields = {
    start_date: null,
    time: null,
};

export default {
    components: {
        XModal,
        XFormGroup,
        XCloseModalButton,
        XSubmitButton,
        XInputDevotionCategory,
    },
    computed: {
        formId() {
            return `${this.id}-form`;
        },
        title() {
            return this.resource
                ? `Publish ${this.resource.display_name}`
                : "Publish";
        },
    },
    data() {
        return {
            fields: {
                ...defaultFields,
            },
            isLoading: false,
        };
    },
    methods: {
        handleSubmit() {
            this.isLoading = true;
            const request = Axios.post(
                `/api/translation-upload-batches/${this.resource.id}/convert`,
                this.fields
            ).then(() => {
                this.$notify({
                    type: "success",
                    title: `Berhasil`,
                    text: `${this.resource.display_name} dipublish!`,
                });
                this.fields = { ...defaultFields };
                $(`#${this.id}`).modal("hide");
                this.$emit("converted");
            });
            return handleValidationXhrError(
                request,
                (errors) => (this.errors = errors)
            ).finally(() => {
                this.isLoading = false;
            });
        },
    },
    mixins: [FormErrorMixin],
    props: {
        id: {
            type: String,
            required: false,
            default: "conversion-modal",
        },
        resource: {
            type: Object,
            required: false,
            default: null,
        },
    },
};
</script>
